module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-11-4db639c8f9e4ff9fd8954b51f98ee529.png";